import classNames from "classnames";

export const PageHeader = ({
  title,
  children,
  className,
}: {
  title: string;
  children?: JSX.Element;
  className?: string;
}) => {
  return (
    <div
      className={classNames(
        "flex tablet:hidden flex-row flex-shrink-0 px-4 h-[72px] w-full justify-between items-center border-b border-pinball bg-white",
        className,
      )}
    >
      <h2 className="text-xl font-semibold">{title}</h2>
      {children}
    </div>
  );
};
